import hateoas from 'viralstyle-ui/src/hateoas';
import storage from 'viralstyle-ui/src/storage';
import eventHub from 'viralstyle-ui/src/eventHub';

import keenIO from '../../../utils/keen-io';
import { CartModel } from './models';

export const getCart = async ({ rootState, state, dispatch, commit }) => {
  try {
    let response = await dispatch('get', storage.get('cart')),
      idArray = response.data._links.self.split('/'),
      id = idArray[idArray.length - 1];

    response.data.id = id;

    commit('updateState', { object: state, property: 'cart', value: response.data });

    if (state.cart.removed_items.length) {
      commit('addNotification', 'Some items have automatically been removed from your cart because they are no longer available.');

      if (!state.cart.items.length) storage.remove('cart');
    } else if (state.cart.items.length) {
      response = await dispatch('get', state.cart._links.campaigns_tracking);

      commit('updateState', { object: state.cart, property: 'tracking', value: response.data });
    }

    return response;
  } catch (e) {
    if (!e.requiresLogin) storage.remove('cart');
    throw e;
  }
};

export const patchCartGeo = async ({ rootState, state, dispatch }) => {
  if (rootState.checkout.customer.country) {
    let payload = {},
      response;

    payload.country = rootState.checkout.customer.country;
    payload.province = rootState.checkout.customer.province || "";
    payload.postal_code = rootState.checkout.customer.postal_code || "";

    response = await dispatch('patch', { apiUrl: state.cart._links.patch_geo, payload });

    storage.set('cart', response.cart);

    dispatch('getCart');

    return response;
  }
};

export const addToCart = async ({ rootState, state, dispatch, commit }, { cpid, quantity, size }) => {
  let payload = {},
    product = {
      cpid,
      quantity,
      size,
    },
    tracking = rootState.sales.UTMTracking.toParams(),
    response,
    affiliate = storage.get('affiliate');

  if (!state.cart.items.length) {
    if (tracking) {
      payload.tracking = tracking;
    }

    if (rootState.checkout.customer.email) {
      payload.customer_email = rootState.checkout.customer.email;
    }

    if (affiliate) {
      payload.affiliate_code = affiliate.aid;
    }

    payload.keen_visit_id = keenIO.id;

    payload.products = [product];

    response = await dispatch('post', {
      apiUrl: hateoas.url('create_cart'),
      payload,
    });

    storage.set('cart', response.cart);
    
    storage.remove('affiliate');
    
    response = await dispatch('getCart');
    
    dispatch('patchCartGeo');
  } else {
    response = await dispatch('patch', {
      apiUrl: state.cart._links.add_product,
      payload: product,
    });

    storage.set('cart', response.cart);
    response = await dispatch('getCart');
  }

  return response;
};

export const removeFromCart = async ({ rootState, state, dispatch, commit }, item) => {
  let payload = {
      quantity: 0,
    },
    response;

  if (state.cart.items.length > 1) {
    response = await dispatch('patch', {
      apiUrl: item._links.change_quantity,
      payload,
    });

    storage.set('cart', response.cart);
    dispatch('getCart');
  } else {
    response = await dispatch('deleteCart');

    if (!rootState.cartStyle) {
      commit('updateState', { object: rootState, property: 'cartOpen', value: false });
      commit('lockScroll', false);
    } else if (rootState.cartStyle) {
      dispatch('navigateToRecentCampaignOrMarketplace');
    }
  }

  return response;
};

export const deleteCart = async ({ rootState, state, dispatch, commit }) => {
  let response = await dispatch('del', state.cart._links.delete);

  storage.remove('cart');

  commit('updateState', {
    object: state,
    property: 'cart',
    value: new CartModel(),
  });

  return response;
};

const resetCoupon = async (dispatch, commit, state) => {
  let response = await dispatch('getCart');

  commit('updateState', { object: state, property: 'coupon', value: null, });

  commit('updateState', { object: state, property: 'couponInputVisible', value: false, });

  return response;
};

export const applyCoupon = async ({ dispatch, commit, state }) => {
  if (state.coupon) {
    try {
      let response = await dispatch('patch', { apiUrl: state.cart._links.add_coupon, payload: { coupon_code: state.coupon } });

      commit('addNotification', `Coupon code ${state.coupon} applied to cart.`);

      dispatch('eventApplyCoupon', state.coupon);

      response = await resetCoupon(dispatch, commit, state);

      return response;
    } catch (e) {
      if (e.status === 404) commit('addNotification', `Coupon code ${state.coupon} is invalid.`);

      await resetCoupon(dispatch, commit, state);

      throw e;
    }
  }
};

export const changeQuantity = async ({ dispatch, commit }, { item, quantity }) => {
  let response = await dispatch('patch', { apiUrl: item._links.change_quantity, payload: { quantity } });

  dispatch('getCart');

  return response;
};